import React from 'react';
import {
  Formik, Form, useFormikContext,
  Field,
} from 'formik';
import * as Yup from 'yup';
import { Button } from 'primereact/button';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import AbilityData from './AbilityData';
import { DropdownComponent } from '../../../components/prime-formik';

const i18nMessages = defineMessages({
  competency: {
    id: 'menu.item-bank-management.competency',
    defaultMessage: 'Competency',
  },
});

const AddAbilityToExistingCompetency = ({ currentAccount, availableCompetencies }) => {
  const { formatMessage } = useIntl();
  const history = useHistory();
  const {
    setFieldValue,
    values: { ability },
  } = useFormikContext();

  const initialValues = {
    competencyId: ability.competencyId ? ability.competencyId : '',
    code: ability.code ? ability.code : '',
    displayName: ability.displayName ? ability.displayName : '',
    description: ability.description ? ability.description : '',
  };

  const validationSchema = Yup.object({
    competencyId: Yup.string().required(),
    code: Yup.string().required(),
    displayName: Yup.string().required(),
    description: Yup.string().required(),
  });

  const competenciesOptions = availableCompetencies
    .map(competency => ({
      value: competency.id,
      label: competency.displayName,
    }));

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values, formikBag) => {
        formikBag.resetForm();

        setFieldValue('ability', { ...values });

        history.push(`/accounts/${currentAccount}/add-itembank-survey-content/update/add-survey-items`);
      }}
      render={({ handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <AbilityData />

          <div className="context-option-controls">
            <div className="input-label">{formatMessage(i18nMessages.competency)}</div>
            <div>
              <Field
                id="competencyId"
                name="competencyId"
                component={DropdownComponent}
                options={competenciesOptions}
              />
            </div>
          </div>
          <div>
            <FormattedMessage id="actions.save" defaultMessage="Save">
              {text => <Button type="submit" label={text} />}
            </FormattedMessage>
            <FormattedMessage id="actions.cancel" defaultMessage="Cancel">
              {text => (
                <Button type="button" onClick={() => history.goBack()} className="p-button-secondary" label={text} />
              )}
            </FormattedMessage>
          </div>
        </Form>
      )}
    />
  );
};

AddAbilityToExistingCompetency.propTypes = {
  currentAccount: PropTypes.string.isRequired,
  availableCompetencies: PropTypes.arrayOf(PropTypes.any).isRequired,
};

export default AddAbilityToExistingCompetency;
